import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { BiBulb } from "react-icons/bi";

const useStylesIdeaTemplateSelectCard = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    labelName:{
        fontFamily: 'VodafoneRg-bold', 
        margin: '0 0 0.5rem 0', 
        fontSize: '1.125rem',
        textAlign: 'left',
        color:"#333",
        display:'block',
    },
    ideaTemplateCardBox:{
        backgroundColor: 'rgba(230, 0, 1, 0.09)',
        padding:'1rem',
        border:0,
        borderRadius:'4px',
    },
    selectedTemplate:{
        boxShadow: '-3px 4px 1px #ec2828'
    },
    selectbtn:{
        color: '#fff',
        border: '1px solid',
        borderColor:'#e60000', 
        display: 'block',
        padding: '0.5rem',
        fontSize: '1rem',
        boxSizing: 'border-box',
        textAlign: 'center',
        transition: 'all 300ms ease',
        fontFamily: 'VodafoneRg-Regular',
        borderRadius: '5px',
        backgroundColor: '#e60000',
    }
    
}));

export const IdeaTemplateSelectCard = (props) => {
    // alert("")
    const { ideaName,currentIndex,onClick,selectedTemplateId,idealistId} = props || {}
    // console.log('challengeTemplateIdchallengeTemplateIdchallengeTemplateIdchallengeTemplateIdchallengeTemplateIdchallengeTemplateId', props)
    
  const classes =  useStylesIdeaTemplateSelectCard()
    return(
        <div className={`${classes.ideaTemplateCardBox}  ${selectedTemplateId !== idealistId ? null : classes.selectedTemplate}`}>
            <span><BiBulb /></span>
            <h3 className={classes.labelName}>{ideaName}</h3>
            {selectedTemplateId !== idealistId ? <button type='button' onClick={onClick} className={classes.selectbtn}>Select</button> : 
            <button type='button' className={classes.selectbtn}>Selected</button> }
        </div>
    )
}